import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { BRAND, ASSETS } from "../data/content";

// ARTIST FEATURE — cinematic editorial: artist image masked behind oversized type.
export default function ArtistFeature() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative w-full py-28 md:py-40 overflow-hidden"
      data-testid="section-about"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid md:grid-cols-12 gap-8 md:gap-4 items-center">
        {/* image */}
        <div className="md:col-span-6 md:col-start-1 relative">
          <div className="relative overflow-hidden rounded-sm">
            <motion.img
              src={ASSETS.portraitCar}
              alt={`${BRAND.name} — artist portrait`}
              style={{ y }}
              className="w-full h-[520px] md:h-[720px] object-cover object-top scale-110 grayscale-[0.15] contrast-[1.05]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--void)] via-transparent to-transparent" />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
          </div>
          {/* floating meta */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="absolute -bottom-6 left-4 md:left-8 glass px-5 py-3"
          >
            <p className="track-label text-white/70">Artist. Creator. Visionary.</p>
          </motion.div>
        </div>

        {/* type */}
        <div className="md:col-span-6 md:pl-10 relative z-10">
          <h2 className="font-display chrome-text text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight mb-8">
            <Reveal text={BRAND.name} />
          </h2>
          <p className="font-body text-base md:text-lg text-white/70 leading-relaxed max-w-xl">
            <Reveal
              text={`\u201C${BRAND.name} exists at the intersection of music, visual storytelling, fashion, culture and experience. ${BRAND.phrase} is more than a phrase \u2014 it is the world behind the music.\u201D`}
              delay={0.1}
            />
          </p>
        </div>
      </div>
    </section>
  );
}
